
    require('./gauge/GaugeSeries');
    require('./gauge/GaugeView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/gauge.js
// module id = 87tG
// module chunks = 5